module.exports = __webpack_public_path__ + "img/Shaman-troll-f-70.fc835088.gif";